"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});
var filterClasses = exports.filterClasses = {
	OVERVIEW: ["OVERVIEW"],
	DETAIL: ["OVERVIEW", "DETAIL"],
	FULL: ["FULL", "OVERVIEW", "DETAIL"]
};